var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modalContainer"},[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"errorModal"},[_c('h2',[_vm._v("Error")]),_vm._l((_vm.$store.state.ERRORS),function(error,index){return _c('p',{key:index},[_vm._v(_vm._s(error))])})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }